import { SocketSubscription } from '@mode/shared/data-access-socket';
import { createAction, props } from '@ngrx/store';
import { GoogleSheetRunPusherSuccessPayload } from '@mode/dataset/google/contract';

export const datasetEditorSyncGoogleSheet = createAction(
  '[DatasetEditor] Sync Google Sheet',
  props<{ accountId: string; datasetId: string }>()
);

export const syncGoogleSheetSuccess = createAction('[GoogleSheetSync/API] Sync Google Sheet Success');

export const syncGoogleSheetFailure = createAction(
  '[GoogleSheetSync/API] Sync Google Sheet Failure',
  props<{ error: any }>()
);

export const startGoogleSheetSyncSuccess = createAction(
  '[GoogleSheetSync] Start Google Sheet Sync Success',
  props<{ channelName: string }>()
);

export const googleSheetSyncSocketConnectionSuccess = createAction(
  '[GoogleSheetSync] Create Google Sheet Sync Socket Connection Success',
  props<{
    googleSheetSyncSubscription: SocketSubscription<GoogleSheetRunPusherSuccessPayload>;
  }>()
);

export const googleSheetSyncEnqueued = createAction('[GoogleSheetSync] Google Sheet Sync Enqueued');

export const refreshGoogleSheetDataset = createAction('[GoogleSheetSync] Refresh Google Sheet Dataset');
